import { render, staticRenderFns } from "./modal-find-replace-with-breed-name.vue?vue&type=template&id=23a64bc8&scoped=true&lang=pug"
import script from "./modal-find-replace-with-breed-name.js?vue&type=script&lang=js&external"
export * from "./modal-find-replace-with-breed-name.js?vue&type=script&lang=js&external"
import style0 from "./modal-find-replace-with-breed-name.vue?vue&type=style&index=0&id=23a64bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a64bc8",
  null
  
)

export default component.exports